<template>
  <div class="error-wrapper">
    <div class="error-icon">
      <i class="material-icons">error_outline</i>
    </div>
    <div class="error-text">
      <h1>{{getStateWithParam(message)}}</h1>
      <span>{{getStateWithParam(subMessage)}}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: "BaseDefaultError",
  props: {
    message: {
      type: [String]
    },
    subMessage: {
      type: [String]
    }
  },
  methods: {
    getStateWithParam(param) {
      return this.$store.getters.getLanguageParameters(param);
    }
  }
};
</script>

<style lang="scss" scoped>
.error-wrapper {
  position: fixed;
  top: 0px;
  left: 0px;
  z-index: 5;
  background-color: white;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  .error-icon {
    i {
      font-size: 100px;
    }
  }
  .error-text {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
}
</style>